import { render, staticRenderFns } from "./RentalDevicesList.vue?vue&type=template&id=2bd395b7&scoped=true&"
import script from "./RentalDevicesList.vue?vue&type=script&lang=ts&"
export * from "./RentalDevicesList.vue?vue&type=script&lang=ts&"
import style0 from "./RentalDevicesList.vue?vue&type=style&index=0&id=2bd395b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd395b7",
  null
  
)

export default component.exports